import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'es', label: 'ES', flag: 'Espanol' },
  { code: 'en', label: 'EN', flag: 'English' },
  { code: 'pt', label: 'PT', flag: 'Portugues' },
  { code: 'fr', label: 'FR', flag: 'Francais' },
  { code: 'it', label: 'IT', flag: 'Italiano' },
  { code: 'de', label: 'DE', flag: 'Deutsch' },
];

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div ref={ref} className="relative" data-testid="language-selector">
      <button
        data-testid="language-selector-btn"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold text-white/70 hover:text-white bg-[hsl(var(--surface))] border border-[hsl(var(--border)/0.4)] hover:border-[hsl(var(--primary-glow)/0.5)] transition-all duration-200"
      >
        <Globe className="w-3.5 h-3.5" />
        {current.label}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 py-1 rounded-lg bg-[hsl(var(--surface-elevated))] border border-[hsl(var(--border)/0.5)] shadow-[0_8px_30px_rgba(0,0,0,0.4)] z-50 min-w-[140px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              data-testid={`lang-option-${lang.code}`}
              onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3 py-2 text-xs transition-colors duration-150 ${
                i18n.language === lang.code
                  ? 'text-[hsl(var(--primary-glow))] bg-[hsl(var(--primary)/0.15)]'
                  : 'text-white/70 hover:text-white hover:bg-[hsl(var(--surface))]'
              }`}
            >
              <span className="font-bold w-5">{lang.label}</span>
              <span className="text-white/50">{lang.flag}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
